import config_ext from '../../config_ext.js';

const prod = {
    env: 'PROD',
    url: {
        API_URL: 'https://api.bstage.io',
        BannerService: 'https://backstage.erate.co.il',
        MediaService: 'https://media.bstage.io',
    }
};
// XXX colin: remove after the switch: the native linux hosts on new
// subdomains (nginx back_web_nginx), in parallel with windows prod
const parallel = {
    env: 'PROD',
    url: {
        API_URL: 'https://api2.bstage.io',
        BannerService: 'https://media2.bstage.io',
        MediaService: 'https://media2.bstage.io',
    }
};
const pre = {
    env: 'PRE',
    url: {
        API_URL: "http://newapi.bstage.io", 
        BannerService: "http://newapi.bstage.io",
        MediaService: "http://newapi.bstage.io",
    }
};
const local_22 = {
    env: 'DEV_TEST',
    url: {
        API_URL: "http://backstage_api.b-soft.co.il", //  10.22
        BannerService: "http://backstage_api.b-soft.co.il",
        MediaService: "http://backstage_api.b-soft.co.il",
    }
};

const dev = {
    env: 'DEV',
    url: {
        API_URL: "http://localhost:51509", 
        BannerService: "http://localhost:51509",
        MediaService: "http://localhost:51509",
    }
};
const getConfig = () => {

    // explicit backend for local / non-prod builds, set at build time (prod
    // config_ext also has back.api.url, prod builds use the hostname below)
    if(!config_ext.is_prod && config_ext.back?.api?.url){
        const url = config_ext.back.api.url;
        return { env: 'LOCAL', url: { API_URL: url, BannerService: url, MediaService: url } };
    }
    if(import.meta.env.PROD){
        if(window.location.href.toLowerCase().indexOf('backstageapp.b-soft.co.il') >= 0){
            return local_22;
        }
        if(window.location.hostname.toLowerCase() == 'app2.bstage.io'){
            return parallel;
        }
        if(window.location.href.toLowerCase().indexOf('new.bstage.io') >= 0){
            return pre;
        }
        return prod;
    }
    return dev;
};

export const constConfig = getConfig();
